"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const react_ga_1 = __importDefault(require("react-ga"));
const constants_1 = require("../../assets/constants/constants");
const HeaderMenuComponent_1 = __importDefault(require("../../components/headerMenuComponent/HeaderMenuComponent"));
const FormSuite_1 = __importDefault(require("../../hooks/FormSuite"));
const PagseguroContext_1 = require("../../hooks/PagseguroContext");
const detectDevice_1 = __importDefault(require("../../utils/detectDevice"));
const HomeFooter_1 = __importDefault(require("../home/homeFooter/HomeFooter"));
const AbstractPayment_1 = __importDefault(require("./abstractPayment/AbstractPayment"));
const ConfirmPay_1 = __importDefault(require("./confirmPay/ConfirmPay"));
const PaymentBookingStyle_1 = require("./PaymentBookingStyle");
const ConfirmValuesContext_1 = require("./context/ConfirmValuesContext");
const ConfirmedBooking = () => {
    const { isMobile } = (0, detectDevice_1.default)(constants_1.SCREEN_WIDTH.mobile);
    (0, react_1.useEffect)(() => {
        react_ga_1.default.pageview(window.location.pathname + window.location.search);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HeaderMenuComponent_1.default, null),
        react_1.default.createElement(FormSuite_1.default, null,
            react_1.default.createElement(ConfirmValuesContext_1.ConfirmValuesProvider, null,
                react_1.default.createElement(PagseguroContext_1.PagseguroProvider, null,
                    react_1.default.createElement(PaymentBookingStyle_1.ContainerBody, null,
                        react_1.default.createElement(antd_1.Col, { span: isMobile ? 24 : 8 },
                            react_1.default.createElement(AbstractPayment_1.default, { disabledCoupon: false, isFromConfirmedBooking: true })),
                        react_1.default.createElement(antd_1.Col, { span: isMobile ? 24 : 16 },
                            react_1.default.createElement(ConfirmPay_1.default, null)))))),
        react_1.default.createElement(HomeFooter_1.default, null)));
};
exports.default = ConfirmedBooking;
